import whiteListedDomainToLineMap from './whitelist';

/**
 * Takes a hostname and returns the prod line
 *
 * @param {string} hostname - the hostname to check against
 * @param {Object} config - Optional configurations
 * @param {string} config.default - default return for non-match of allowlist
 * @return {string} - line that is expected for that url
 */
const getLineFromHost = (hostname, config = {}) => (whiteListedDomainToLineMap[hostname] || config?.default || 'e1-np');

export default getLineFromHost;
